import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faSpinner } from '@fortawesome/free-solid-svg-icons'

class TableTitle extends React.Component {
  render() {
    const {
      classes,
      onIconClick,
      iconLabel,
      header,
      addIcon = true,
      withBottomBorder,
      customButtons = []
    } = this.props

    return (
      <Toolbar
        className={classNames(classes.titleRoot)}
        style={{
          borderBottom: withBottomBorder
            ? '1px solid rgba(224, 224, 224, 1)'
            : 'transparent'
        }}
      >
        <div className={classes.title}>
          <Typography variant="title" id="tableTitle">
            {header}
          </Typography>
        </div>
        <div className={classes.spacer} />
        {addIcon ? (
          <div className={classes.actions}>
            <Tooltip title={iconLabel}>
              <IconButton aria-label={iconLabel} onClick={() => onIconClick()}>
                <FontAwesomeIcon icon={faPlus} color={'#289e64'} />
              </IconButton>
            </Tooltip>
          </div>
        ) : null}
        {customButtons.length === 0 ? null : (
          <div className={classes.actions} style={{ display: 'flex' }}>
            {customButtons.map((button, index) => {
              const { label, onClick, icon, color, loading } = button

              if (loading) {
                return (
                  <div
                    key={index}
                    style={{ display: 'flex', alignItems: 'center', padding: '8px 12px' }}
                  >
                    <FontAwesomeIcon icon={faSpinner} spin color="#999" style={{ fontSize: 16 }} />
                    <span style={{ marginLeft: 8, fontSize: 12, color: '#999' }}>{label}</span>
                  </div>
                )
              }

              return (
                <Tooltip key={index} title={label}>
                  <IconButton aria-label={label} onClick={() => onClick()}>
                    <FontAwesomeIcon
                      icon={icon}
                      color={color}
                      style={{ fontSize: 16 }}
                    />
                  </IconButton>
                </Tooltip>
              )
            })}
          </div>
        )}
      </Toolbar>
    )
  }
}

TableTitle.propTypes = {
  classes: PropTypes.object.isRequired
}

export { TableTitle }



// WEBPACK FOOTER //
// ./src/components/common/TableTitle.js